import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function TheSystem() {
  const tomos = [{
    icon: '📚',
    title: 'TOMO 1: FASE DE DESMONTE (LIMPIEZA DE OBRA)',
    content: <>
          <p data-id="element-320">
            El folículo está tapado por sebo calcificado, siliconas y residuos.
            Si no limpiás eso primero, ningún tónico llega.
          </p>
          <p className="text-gold font-bold mt-4" data-id="element-321">
            Resultado: cuero cabelludo limpio, poros abiertos, piel móvil.
            Terreno listo.
          </p>
        </>
  }, {
    icon: '📚',
    title: 'TOMO 2: LABORATORIO BOTÁNICO (EL ELIXIR DE INFUSIÓN)',
    content: <>
          <p data-id="element-322">
            El romero mostró efectos equivalentes al Minoxidil (Universidad de
            Hacettepe, 2015). Pero los shampoos comerciales tienen 0.1% de
            concentración. Lo que preparás acá tiene 10-20x más.
          </p>
          <p className="text-gold font-bold mt-4" data-id="element-323">
            5 preparados: Tónico de Romero y Ortiga, Cola de Caballo, Ginkgo
            Biloba, Concentrado 10:1 y Aceite Macerado.
          </p>
        </>
  }, {
    icon: '📚',
    title: 'TOMO 3: BLINDAJE HORMONAL (ESCUDO ANTI-DHT)',
    content: <>
          <p data-id="element-324">
            La DHT miniaturiza el pelo hasta que desaparece. Bloqueamos su
            acción de forma tópica con cafeína, fitosteroles de calabaza y
            lectinas de ortiga. Sin efectos secundarios. Sin pastillas.
          </p>
          <p className="text-gold font-bold mt-4" data-id="element-325">
            4 preparados: Tónico de Cafeína, Aceite Bloqueador, Infusión de
            Canela y Sérum Anti-DHT Integral.
          </p>
        </>
  }, {
    icon: '📚',
    title: 'TOMO 4: TURBINA DE RIEGO (IRRIGACIÓN MECÁNICA)',
    content: <>
          <p data-id="element-326">
            Si la sangre no llega al folículo, los nutrientes tampoco. Masajes
            de desplazamiento, método de inversión y protocolo post-tónico que
            triplica la absorción.
          </p>
          <p className="text-gold font-bold mt-4" data-id="element-327">
            20 minutos por día divididos entre mañana y noche.
          </p>
        </>
  }, {
    icon: '📚',
    title: 'TOMO 5: COMBUSTIBLE BIOLÓGICO (NUTRICIÓN DE ACERO)',
    content: <>
          <p data-id="element-328">
            El pelo se fabrica desde adentro. Si tu sangre está pobre en zinc,
            biotina, hierro y proteínas, el folículo no tiene con qué trabajar.
          </p>
          <p className="text-gold font-bold mt-4" data-id="element-329">
            Incluye el Licuado de Carga Capilar + suplementos de dietética:
            levadura de cerveza, semillas de calabaza, polen, caldo de huesos.
          </p>
        </>
  }, {
    icon: '📚',
    title: 'TOMO 6: OPERATIVO FACHA (MANTENIMIENTO Y CONTROL)',
    content: <>
          <p data-id="element-330">
            Método de lavado definitivo, 7 técnicas de reducción de cortisol,
            guía de camuflaje natural y el Calendario de Guerra Capilar: tu
            rutina diaria de 20-35 minutos.
          </p>
        </>
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-331">
      <div className="max-w-4xl mx-auto" data-id="element-332">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-333">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-334">
            EL SISTEMA QUE ATACA LA CALVICIE DESDE 6 FRENTES SIMULTÁNEOS
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-335">
            El Sistema Megakit no es un shampoo. No es una pastilla. No es un
            ingrediente mágico. Es un{' '}
            <strong className="text-gold" data-id="element-336">sistema de 6 tomos</strong> que ataca
            el problema capilar de la misma forma en que ataca un problema
            estructural un ingeniero: desde todos los ángulos posibles al mismo
            tiempo.
          </p>
        </motion.div>

        <div className="space-y-8 mb-16" data-id="element-337">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-50 p-6 md:p-8 rounded-lg border border-gray-200 hover:border-green-300 transition-colors" data-id="element-338">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 flex items-start gap-3" data-id="element-339">
                <span className="text-2xl mt-1" data-id="element-340">{tomo.icon}</span>
                <span data-id="element-341">{tomo.title}</span>
              </h3>
              <div className="space-y-4 text-gray-600 text-lg leading-relaxed" data-id="element-342">
                {tomo.content}
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-343">
          <CTAButton data-id="element-344">SÍ, QUIERO EL SISTEMA MEGAKIT</CTAButton>
        </div>
      </div>
    </section>;
}